export default {
    FETCH_DATA_BATCH_SIZE: 20,
    MAX_BATCHES: 10,
    FETCH_DATA_EXPIRE_SEC: 30,
};
